/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicLanguageNotSupportedGuard,
  UnexpectedServiceErrorGuard
} from '../../../share/guards'
import WordCloudEmptyResultGuard from './WordCloudEmptyResultGuard'
import WordCloudBelowThresholdGuard from './WordCloudBelowThresholdGuard'

const WordCloudWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <TopicLanguageNotSupportedGuard widgetId={widgetId}>
          <WordCloudEmptyResultGuard widgetId={widgetId}>
            <WordCloudBelowThresholdGuard widgetId={widgetId}>
              {children}
            </WordCloudBelowThresholdGuard>
          </WordCloudEmptyResultGuard>
        </TopicLanguageNotSupportedGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default WordCloudWidgetDataGuards
